import { inject, Injectable } from "@angular/core";
import { BusinessVerificationData } from "../../../../../../../models/order/workflow/wireless/wireless-flow.model";
import { WirelessFlowStateService } from "../wireless-flow-state.service";
import { BaseWorkflowStateService } from "../../base-workflow-state.service";
@Injectable({ providedIn: 'root' })
export class BusinessVerificationStateService extends BaseWorkflowStateService<BusinessVerificationData> {
    private flowStateService = inject(WirelessFlowStateService);
    override stateKey: string = 'businessVerification';

    protected override saveLocalDraft(): void {
        this.flowStateService.updateData({ businessVerification: this.state() });
    }

    resetData() {
        this.state.set(null);
        this.saveLocalDraft();
    }

}